<template>
	<div>
		<DashboardOverview
			:is-loading="productOverview.isLoading"
			:from-itec="totalSkuITECCount"
			:online-stock="onlineStockCount"
			:active-sku="activeSkuCount"
			:inactive-sku="inactiveSkuCountProductOverview"
			:eol-sku="eolSkuCount"
		/>
		<div class="mt-4">
			<DashboardProductStatus
				:is-loading="productStatus.isLoading"
				:active-tab="productStatusTabIndex"
				:new-skus="productStatus.data.newSkus"
				:inactive-skus="productStatus.data.inactiveSkus"
			/>
		</div>
		<CRow class="mt-4">
			<CCol xl="8">
				<DashboardFastmove
					:is-loading="fastMoveProduct.isLoading"
					:active-tab="fastmoveTabIndex"
					:skus="fastMoveProduct.data"
					@onFilterChange="handleFastmoveFilterChange"
				/>
			</CCol>
			<CCol xl="4">
				<DashboardChannelStockStatus
					:is-loading="stockStatus.isLoading"
					:channels="stockStatus.data"
				/>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DashboardOverview from '../components/DashboardOverview.vue';
import DashboardProductStatus from '../components/DashboardProductStatus.vue';
import DashboardFastmove from '../components/DashboardFastmove.vue';
import DashboardChannelStockStatus from '../components/DashboardChannelStockStatus.vue';
import { numberFormat } from '../helpers/utils';

export default {
	name: 'Dashboard',

	components: {
		DashboardOverview,
		DashboardProductStatus,
		DashboardFastmove,
		DashboardChannelStockStatus,
	},

	data() {
		return {
			productStatusTabIndex: 0,
			fastmoveTabIndex: 0,
		};
	},

	computed: {
		...mapState('dashboard', {
			productStatus: 'productStatus',
			productOverview: 'productOverview',
			stockStatus: 'stockStatus',
			fastMoveProduct: 'fastMoveProduct',
		}),
		totalSkuITECCount() {
			return numberFormat(this.productOverview.data.totalSkuITECCount);
		},
		onlineStockCount() {
			return numberFormat(this.productOverview.data.onlineStockCount);
		},
		activeSkuCount() {
			return numberFormat(this.productOverview.data.activeSkuCount);
		},
		inactiveSkuCountProductOverview() {
			return numberFormat(this.productOverview.data.inactiveSkuCount);
		},
		eolSkuCount() {
			return numberFormat(this.productOverview.data.eolSkuCount);
		},
	},

	created() {
		this.fetchData();
	},

	mounted() {
		// set content background to gray color
		this.setCBodyClass('c-body-bg-color-gray');
	},

	destroyed() {
		// set content background to default color
		this.setCBodyClass(null);
	},

	methods: {
		...mapActions('app', {
			setCBodyClass: 'setCBodyClass',
		}),
		...mapActions('dashboard', {
			getDashboardProductStatus: 'getDashboardProductStatus',
			getDashboardProductOverview: 'getDashboardProductOverview',
			getDashboardChannelStockStatus: 'getDashboardChannelStockStatus',
			getDashboardFastMoveProduct: 'getDashboardFastMoveProduct',
		}),
		fetchData() {
			return Promise.all([
				this.getDashboardProductStatus(),
				this.getDashboardProductOverview(),
				this.getDashboardChannelStockStatus(),
				this.getDashboardFastMoveProduct({ filter: 'filter_type_day' }),
			]);
		},
		handleFastmoveFilterChange({ date }) {
			return this.getDashboardFastMoveProduct({ filter: date });
		},
	},
};
</script>
